<template>
    <b-row class="property-details-summary">
        <b-col
                cols="12"
                md="7"
                class="address-col order-0"
        >
            <h1
                    class="mb-0 address"
                    v-if="address && address.street"
            >
                {{ address.street }}
            </h1>
            <h1
                    class="mb-0 address"
                    v-else
            >
                Address Not Disclosed
            </h1>
            <template
                    v-if="address"
            >
                <h3 class="address">
                    {{ address.city }}, {{ address.state }} {{ address.postalCode }}
                </h3>
            </template>
            <div class="details">
                <b-row>
                    <b-col
                            class="detail-container"
                            cols="3"
                    >
                        <i class="details-icons fas fa-bed mr-1" />
                        <span class="strong mr-1">{{ propertyAppResource.bedrooms }}</span>
                        {{ beds }}
                    </b-col>
                    <b-col
                            class="detail-container"
                            cols="3"
                    >
                        <i class="details-icons fas fa-bath mr-1" />
                        <span class="strong mr-1">{{ propertyAppResource.bathrooms }}</span>
                        {{ baths }}
                    </b-col>
                    <b-col
                            class="detail-container"
                            cols="3"
                    >
                        <i class="details-icons fas fa-ruler-triangle mr-1" />
                        <span class="strong mr-1">
                            {{ propertyAppResource.size | niceNumberFormat }}
                        </span>
                        {{ sizeUnit }}
                    </b-col>
                </b-row>
            </div>
        </b-col>
        <b-col
                class="text-md-right pt-4 pt-md-0 order-1"
                cols="6"
                md="3"
        >
            <h1
                    class="price"
                    v-if="price"
            >
                {{ formatNumber(price) }}
            </h1>
            <h3
                    v-if="propertyPreviousPrice"
                    class="price-subheading-strike"
            >
                {{ propertyPreviousPrice }}
                <i class="price-info fal fa-info-circle ml-1 mt-1" />
            </h3>
            <b-button
                    v-if="activeActionButtons.includes('finance')"
                    class="action-btn-get-pre-qualified ml-auto"
                    variant="outline-secondary"
                    block
                    @click="handleRequestButtonClick(PROPERTY_SEARCH_ACTIONS.FINANCE)"
            >
                Get Pre-Qualified
            </b-button>
        </b-col>
        <b-col
                cols="6"
                md="2"
                class="mt-3 mt-md-1 order-2"
        >
            <div
                    v-if="hasCoordinates"
                    :style="{backgroundSize: '125%', backgroundImage: `url(${mapImage})`}"
                    class="map d-inline-block float-right"
                    @click="handleMapClick"
            >
                <b-img
                        v-if="hub"
                        v-svg-inline
                        :src="marker"
                />
                <b-img
                        v-else
                        :src="marker"
                />
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import './PropertyDetailsSummary.scss';
    import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
    import {SIZE_UNIT_MAPING, PROPERTY_SEARCH_ACTIONS} from '../../../../helpers/variables';
    import {PROPERTY_DETAILS_MODAL_DISPLAY, TABS}
        from '../PropertyDetailsModal/PropertyDetailsModal';
    import {lotSizeRender, formatNumber} from '../../../../helpers/functions';
    import {PROPERTY_SEARCH_DISABLED_OPTION} from "../../../mixins/PropertySearchMixin";
    import {mapGetters} from 'vuex';

    export default {
        name: 'PropertyDetailsSummary',
        props: {
            propertyAppResource: {
                type: AppResource,
                required: true,
            },
            activeActionButtons: {
                type: Array,
                default: () => []
            },
        },

        data() {
            return {
                SIZE_UNIT_MAPING,
                propertyPreviousPrice: 0,
                marker: require('../../../GoogleMaps/icons/marker.svg'),
                PROPERTY_SEARCH_ACTIONS
            };
        },

        computed: {
            ...mapGetters({
                hub: 'getCurrentWorkspace',
            }),
            address() {
                return this.propertyAppResource.addresses.getFirst();
            },
            sizeUnit() {
                return this.propertyAppResource.sizeUnits &&
                    SIZE_UNIT_MAPING.hasOwnProperty(this.propertyAppResource.sizeUnits) ?
                        SIZE_UNIT_MAPING[this.propertyAppResource.sizeUnits] : '';
            },

            lat() {
                return this.propertyAppResource?.details?.latitude;
            },
            lng() {
                return this.propertyAppResource?.details?.longitude;
            },
            hasCoordinates() {
                return this.lat && this.lng;
            },
            mapImage() {
                if (!this.hasCoordinates) {
                    return '';
                }
                //eslint-disable-next-line
            return `https://maps.googleapis.com/maps/api/staticmap?center=${this.lat},${this.lng}&zoom=15&size=100x150&scale=2&style=element:labels%7Cvisibility:on&style=feature:administrative%7Celement:geometry%7Cvisibility:off&style=feature:administrative.land_parcel%7Cvisibility:off&style=feature:administrative.neighborhood%7Cvisibility:off&style=feature:poi%7Cvisibility:off&style=feature:road%7Celement:labels.icon%7Cvisibility:off&style=feature:transit%7Cvisibility:off&key=${window.env.GOOGLE_API_KEY}`;
            },
            price() {
                let price = this.propertyAppResource.price;
                if (this.propertyAppResource.isSold) {
                    price = this.propertyAppResource.details.salePrice;
                }
                return price;
            },
            beds() {
                return this.propertyAppResource.bedrooms > 1 ? 'beds' : 'bed';
            },
            baths() {
                return this.propertyAppResource.bathrooms > 1 ? 'baths' : 'bath';
            }
        },
        methods: {
            formatNumber,
            handleRequestButtonClick(type) {
                this.$bus.$emit(PROPERTY_SEARCH_DISABLED_OPTION, type, {
                    propertyUuid: this.propertyAppResource.uuid,
                    address: this.propertyAppResource.addresses.getFirst(),
                });
            },

            handleMapClick() {
                this.$bus.$emit(
                    PROPERTY_DETAILS_MODAL_DISPLAY,
                    {
                        property: this.propertyAppResource,
                        tab: TABS.MAP,
                    },
                );
            },
        },
    };
</script>
